import { GtmTrackingType } from '../constants';
import GtmRemoveFromBasketDelegatorInstance from './gtmRemoveFromBasketDelegator';

class GtmRemoveAllFromBasketDelegator {
	constructor() {
		this.type = GtmTrackingType.REMOVE_ALL_FROM_BASKET;
	}

	getTrackingData() {
		const cart = document.querySelector('[data-gtm-cart]');
		let objectCollection;

		if (cart) {
			objectCollection = Array.from(
				cart.querySelectorAll('[data-gtm-data-store="true"]'),
			).map(cartItem =>
				GtmRemoveFromBasketDelegatorInstance.getTrackingData(cartItem),
			);
		}

		return objectCollection;
	}
}

const GtmRemoveAllFromBasketDelegatorInstance =
	new GtmRemoveAllFromBasketDelegator();
export default GtmRemoveAllFromBasketDelegatorInstance;

// for test purpose only
export const GtmRemoveAllFromBasketDelegatorClass =
	GtmRemoveAllFromBasketDelegator;
